export const updateRepeatBookingEndpoint = '/berths/bookings/repeat' as const
